import script from "./SizesPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SizesPanel.vue?vue&type=script&setup=true&lang=js"

import "./SizesPanel.vue?vue&type=style&index=0&id=1e9e4e65&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e9e4e65"]])

export default __exports__